import { Directive, inject, OnInit } from '@angular/core';
import { DateAdapter } from '@angular/material/core';
import { MatFormField } from '@angular/material/form-field';
import { DATE_FNS_LOCALES } from '@core/configs/translation/locales.config';
import { LocaleConfig } from '@ogs-gmbh/ngx-translate';
import { LanguageSelectionService } from '@shared/components/language-selection/services/language-selection/language-selection.service';
import { Locale } from 'date-fns';

@Directive({
  selector: '[appLocalizedDatepicker]',
  standalone: true
})
export class LocalizedDatepickerDirective implements OnInit {
  // eslint-disable-next-line @tseslint/no-unsafe-assignment
  private _dateAdapter: DateAdapter<Date> = inject(DateAdapter<Date>);

  private _matFormField: MatFormField = inject(MatFormField);

  private _languageSelectionService: LanguageSelectionService = inject(LanguageSelectionService);

  public ngOnInit (): void {
    this._languageSelectionService.currentLocale$.subscribe({
      next: (newLocale: LocaleConfig) => {
        const dateFnsLocale: Locale | undefined = DATE_FNS_LOCALES[ newLocale.value ];

        this._dateAdapter.setLocale(dateFnsLocale ?? newLocale.value);
      }
    });
  }
}
